
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/stock/situation",
      function () {
        return require("private-next-pages/en/ir/stock/situation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/stock/situation"])
      });
    }
  